/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StatementUpdateStatus } from './StatementUpdateStatus';
import {
    StatementUpdateStatusFromJSON,
    StatementUpdateStatusFromJSONTyped,
    StatementUpdateStatusToJSON,
    StatementUpdateStatusToJSONTyped,
} from './StatementUpdateStatus';

/**
 * The outcome for one requested problem.
 * @export
 * @interface StatementUpdateResult
 */
export interface StatementUpdateResult {
    /**
     * 
     * @type {string}
     * @memberof StatementUpdateResult
     */
    problem_id: string;
    /**
     * 
     * @type {StatementUpdateStatus}
     * @memberof StatementUpdateResult
     */
    status: StatementUpdateStatus;
    /**
     * 
     * @type {number}
     * @memberof StatementUpdateResult
     */
    examples_added?: number;
    /**
     * 
     * @type {number}
     * @memberof StatementUpdateResult
     */
    examples_skipped?: number;
}



/**
 * Check if a given object implements the StatementUpdateResult interface.
 */
export function instanceOfStatementUpdateResult(value: object): value is StatementUpdateResult {
    if (!('problem_id' in value) || value['problem_id'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function StatementUpdateResultFromJSON(json: any): StatementUpdateResult {
    return StatementUpdateResultFromJSONTyped(json, false);
}

export function StatementUpdateResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatementUpdateResult {
    if (json == null) {
        return json;
    }
    return {
        
        'problem_id': json['problem_id'],
        'status': StatementUpdateStatusFromJSON(json['status']),
        'examples_added': json['examples_added'] == null ? undefined : json['examples_added'],
        'examples_skipped': json['examples_skipped'] == null ? undefined : json['examples_skipped'],
    };
}

export function StatementUpdateResultToJSON(json: any): StatementUpdateResult {
    return StatementUpdateResultToJSONTyped(json, false);
}

export function StatementUpdateResultToJSONTyped(value?: StatementUpdateResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'problem_id': value['problem_id'],
        'status': StatementUpdateStatusToJSON(value['status']),
        'examples_added': value['examples_added'],
        'examples_skipped': value['examples_skipped'],
    };
}

